import { graphql } from "@opensea/graphql"
import { CreateOrdersSummaryFragment } from "../../../../../components/CreateOrdersSummary/CreateOrdersSummary.fragment"
import { ListingFlowItemsTableFragment } from "../ListingFlowItemsTable/ListingFlowItemsTable.fragment"

export const ListingFlowForm_itemFragment = graphql(
  `
    fragment ListingFlowForm_item on Item {
      id
      collection {
        chain {
          identifier
          nativeCurrency {
            address
          }
          listingCurrency {
            address
            symbol
          }
        }
        fees {
          openseaFee {
            feeBasisPoints
          }
        }
        ...CreateOrdersSummary
      }
      chain {
        listingCurrency {
          symbol
        }
      }
      lowestListingForOwner(address: $address) {
        __typename
      }
      isFungible
      ...ListingFlowItemsTable
    }
  `,
  [ListingFlowItemsTableFragment, CreateOrdersSummaryFragment],
)
